import {
  FETCH_CREATE_EVENTS_REQUEST,
  FETCH_CREATE_EVENTS_SUCCESS,
  FETCH_CREATE_EVENTS_FAILURE,
} from "../../actions/events/create-event-action";

const initialState = {
  createdEvent: null,
  isLoading: false,
  error: null,
};

const CLEAR_DATA = "CLEAR_DATA";
const CreateEventReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case FETCH_CREATE_EVENTS_REQUEST:
      return {
        ...state,
        isLoading: true,
        error: null,
      };
    case FETCH_CREATE_EVENTS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        createdEvent: { ...action.payload[0] },
      };
    case FETCH_CREATE_EVENTS_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.payload,
      };
    case CLEAR_DATA:
      return {
        ...initialState,
      };
    default:
      return state;
  }
};

export default CreateEventReducer;
